import { useEffect } from "react";
import axios from "axios";
import { useCookies } from "react-cookie"
import { API_BASE } from "../../config/api"

const Logout = () => {
    const [, , removeCookies] = useCookies()

    useEffect(() => {
        axios.post(`${API_BASE}/user/pos-logout`, {}, { withCredentials: true }).finally(() => {
            delete axios.defaults.headers.common['Authorization'];
            removeCookies('auth', { path: '/' });
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <div></div>
}

export default Logout
